import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LearningDashboard = () => {
  const [count, setCount] = useState(0);

  // 🔹 Animate number from 0 → 140
  useEffect(() => {
    let start = 0;
    const end = 140;
    const duration = 2000; // 2 seconds
    const increment = end / (duration / 30);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(timer);
        setCount(end);
      } else {
        setCount(Math.floor(start));
      }
    }, 30);
    return () => clearInterval(timer);
  }, []);

  // 🔹 Free Pexels image (Cybersecurity data visualization)
  const onlineImage =
    "https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&w=1600";

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-700 to-blue-800 text-white p-6 md:p-12 lg:p-20 font-sans">
      {/* Top Section */}
      <div className="flex flex-col lg:flex-row gap-6 mb-12">
        {/* Left Card */}
        <div className="bg-gradient-to-br from-red-500 via-red-400 to-blue-500 p-8 rounded-xl text-center w-full lg:w-80 flex-shrink-0">
          <p className="text-lg font-medium mb-2">More than</p>
          <h1 className="text-5xl font-bold">{count}+</h1>
          <p className="text-lg mt-2">Cybersecurity Modules</p>
          <Link to="./courses" className="mt-6 inline-block">
            <button className="bg-black text-white font-semibold px-6 py-3 rounded-lg hover:bg-gray-800 transition">
              View All Courses
            </button>
          </Link>
        </div>

        {/* Right Card */}
        <div className="bg-gradient-to-br from-blue-600 via-blue-500 to-red-500 p-8 rounded-xl flex-1 min-w-[320px]">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Unlimited learning content, flexible access
          </h2>
          <p className="text-gray-200 text-sm md:text-base mb-4">
            Maximize your employee's learning potential with unrestricted access
            to all courses. HTB Academy continuously releases multiple new
            modules each month, automatically available to your team without any
            extra cost.
          </p>
          <div className="flex gap-3 overflow-x-auto">
            <div className="bg-red-700 px-4 py-2 rounded-lg min-w-[150px] text-center font-medium">
              🐧 Linux Fundamentals
            </div>
            <div className="bg-red-700 px-4 py-2 rounded-lg min-w-[150px] text-center font-medium">
              🌐 Using Web Proxies
            </div>
            <div className="bg-red-700 px-4 py-2 rounded-lg min-w-[150px] text-center font-medium">
              📂 File Inclusion
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-gradient-to-br from-red-500 via-red-400 to-blue-500 p-8 rounded-xl text-center">
        <div className="h-60 bg-black rounded-lg mb-6 flex items-center justify-center overflow-hidden">
          <img
            src={onlineImage}
            alt="Cybersecurity Graph"
            className="w-full h-full object-cover rounded-lg opacity-90 hover:opacity-100 transition"
          />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mb-3">
          Identify skills gaps, monitor employee development
        </h2>
        <p className="text-gray-200 text-sm md:text-base max-w-3xl mx-auto mb-6">
          Track your team’s progress in the Enterprise Platform with integrated
          reporting, and align their skills with real-world job roles using HTB
          Academy’s industry-standard mapping to MITRE ATT&CK and NIST/NICE.
        </p>
        <div className="flex justify-center gap-6 flex-wrap">
          <div className="bg-black px-6 py-3 rounded-lg font-bold text-white">
            MITRE | ATT&CK
          </div>
          <div className="bg-black px-6 py-3 rounded-lg font-bold text-white">
            NIST
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningDashboard;
